import { createContext } from "react";

const WindowWarningContext = createContext();

export default WindowWarningContext;
